<template>
  <section id="content" class="chat">
    <b-container class="my-5">
      <b-row>
        <b-col>
          <b-breadcrumb :items="breadcrumbs" />
        </b-col>
      </b-row>

      <b-row>
        <b-col
          sm="12"
          md="8"
          lg="9"
        >
          <template v-if="currentPost">
<!--            <b-breadcrumb :items="breadcrumbs" />-->
            <post-block :post="currentPost" full @edit-post="editPost" />

            <div id="comments"></div>
            <template v-if="currentPost.comments.length > 0">
              <b-card title="Комментарии:" class="mt-3">
                <comment-block v-for="comment in currentPost.comments.filter(c => !c.parent)" :key="comment.id" :object="currentPost" type="post" :comment="comment" :comments="currentPost.comments" />
              </b-card>
            </template>
            <template v-else>
              <b-card class="mt-3" body-class="pb-0">
                <p>Еще нет комментариев. Будьте первым!</p>
              </b-card>
            </template>

            <template v-if="isUserCanComment">
              <b-card class="mt-3">
                <comment-form :object="currentPost" type="post" />
              </b-card>

            </template>
          </template>

          <template v-else>
            <b-container fluid class="px-0">
              <b-row class="mt-0">
                <b-col>
                  <b-tabs content-class="mt-3" ref="tabs" nav-wrapper-class="card">
                    <b-tab title="О священике" title-item-class="order-5"  @click="activeTab = 'about'">
                      <b-container fluid class="px-0">
                        <b-row>
                          <b-col cols="4" md="4" lg="3">
                            <avatar-block :user="activeParish.priest" change />
                          </b-col>
                          <b-col cols="8" md="8" lg="9">
                            <b-card class="mb-3">
                              <h5>{{ activeParish.priest.fullname }}</h5>
                              <transition name="fade">
                                <template v-if="isEditAboutPriest">
                                  <text-editor v-model="editableAboutPriest" />
                                </template>
                                <div v-else v-html="aboutPriest"></div>
                              </transition>
                            </b-card>
                            <template v-if="isOwner">
                              <b-button v-if="!isEditAboutPriest" size="sm" @click="editAboutPriest()">Редактировать</b-button>
                              <b-button v-else size="sm" @click="saveAboutPriest()" :disabled="saving">
                                <font-awesome-icon v-if="saving" :icon="['fas', 'spinner']" spin />
                                Сохранить
                              </b-button>
                            </template>
                          </b-col>
                        </b-row>
                      </b-container>
                    </b-tab>

                    <b-tab title="Мысли" :active="activeTab === 'post'" @click="activeTab = 'post'">
                      <template v-if="posts.length > 0">
                        <post-block v-for="post in posts.slice((currentPage - 1) * postsPerPage, currentPage * postsPerPage)" :key="post.id" :post="post" @edit-post="editPost" />

                        <b-pagination
                          v-model="currentPage"
                          :total-rows="posts.length"
                          :per-page="postsPerPage"
                          @input="scrollPostsToTop()"
                        />
                      </template>
                      <p v-else>
                        <b-alert
                          variant="warning"
                          show
                        >
                          Тут еще нет записей...
                        </b-alert>
                      </p>
                      <b-button v-if="isOwner" size="sm" @click="addPost()">Добавить статью</b-button>
                    </b-tab>

                    <b-tab title="Фотоальбом" :active="activeTab === 'photo'" @click="activeTab = 'photo'">
                      <template v-if="photos.length > 0">
                        <b-card class="mb-3">
                          <b-container fluid>
                            <b-row>
                              <b-col v-for="photo in photos" :key="photo.id" cols="12" sm="6" lg="4" class="px-1">
                                <photo-block :photo="photo" @click="showPhotoPreview(photo)" />
                              </b-col>
                              <b-col
                                v-if="isOwner"
                                cols="12"
                                sm="6"
                                lg="4"
                                class="px-1"
                              >
                                <b-card no-body @click="addPhoto()" class="add-item cursor">
                                  <b-card-body body-bg-variant="default" class="d-flex justify-content-center align-items-center" style="min-height: 150px;">
                                    <font-awesome-icon :icon="['fas', 'plus']" class="align-middle" v-b-tooltip="'Добавить фото'" />
                                  </b-card-body>
                                </b-card>
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-card>
                        <b-modal id="photo-preview" centered no-close-on-backdrop hide-header hide-footer size="xl" @show="loadComments(currentPhoto)" style="max-height: 80vh;">
                          <b-button-close @click="$bvModal.hide('photo-preview')" class="text-white" style="position: absolute; right: -2%; top: 1%; font-size: 3rem;" />
                          <transition name="fade">
                            <b-container v-if="currentPhoto" fluid :key="currentPhoto.id">
                              <b-row class="px-0">
                                <b-col sm="12" lg="8" class="py-3 image d-flex justify-content-center align-items-center">
                                  <b-button class="prev" :disabled="currentPhotoIndex === 0" variant="link" @click="showPhoto(-1)">
                                    <font-awesome-icon :icon="['fas', 'chevron-left']" />
                                  </b-button>
                                  <b-button class="next" :disabled="currentPhotoIndex === (photos.length - 1)" variant="link" @click="showPhoto(+1)">
                                    <font-awesome-icon :icon="['fas', 'chevron-right']" />
                                  </b-button>

                                  <b-img center :src="currentPhoto.url.full" fluid />

                                  <b-button size="sm" variant="outline-light" class="position-absolute" style="top: 3px; left: 3px;" :pressed="currentPhoto.votes.self" @click="vote('photo')" :disabled="voting" v-b-tooltip="'Количество голосов'">
                                    <font-awesome-icon v-if="!voting" :icon="['fas', 'heart']" />
                                    <font-awesome-icon v-else :icon="['fas', 'spinner']" spin />
                                    <b-badge variant="transparent">{{ currentPhoto.votes.count }}</b-badge>
                                  </b-button>

                                  <b-button size="sm" variant="outline-danger" class="position-absolute" style="top: 3px; right: 3px;" @click="deletePhoto()" :disabled="deleting" v-b-tooltip="'Удалить'">
                                    <font-awesome-icon v-if="!deleting" icon="trash-alt" />
                                    <font-awesome-icon v-else icon="spinner" spin />
                                  </b-button>
                                </b-col>
                                <b-col sm="12" lg="4" class="py-3 comments d-flex flex-column">
                                  <b-row class="flex-grow-1 comments-list">
                                    <b-col class="comments-list" style="font-size: 85%;">
                                      <div v-for="comment in Object.values(currentPhoto.comments).filter(c => !c.parent).reverse()" :key="comment.id" class="mb-1 d-flex flex-row align-items-start">
                                        <b-img :src="comment.author.avatar" rounded="circle" width="30" class="mr-3 mb-1 float-left" />
                                        <div>
                                          <b>{{ comment.author.fullname }}:</b>
                                          <div v-html="comment.message" style="white-space: pre-wrap; word-break: break-all;" />
                                        </div>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <b-row class="mt-2 flex-grow-0">
                                    <b-col>
                                      <comment-form :object="currentPhoto" type="photo" :small="true" />
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-container>
                          </transition>
                        </b-modal>
                      </template>
                      <p v-else>
                        <b-alert
                          variant="warning"
                          show
                        >
                          Тут еще нет записей...
                        </b-alert>
                      </p>
                      <b-button v-if="isOwner" size="sm" @click="addPhoto()">Добавить фото</b-button>
                    </b-tab>

                    <b-tab title="Видеоканал" :active="activeTab === 'video'" @click="activeTab = 'video'">
                      <template v-if="videos.length > 0">
                        <b-card class="mb-3">
                          <b-container fluid>
                            <b-row>
                              <b-col v-for="video in videos" :key="video.id" cols="12" sm="6" lg="4" class="px-1">
                                <video-block :video="video" @click="showVideoPreview(video)" />
                              </b-col>
                              <b-col
                                v-if="isOwner"
                                cols="12"
                                sm="6"
                                lg="4"
                                class="px-1"
                              >
                                <b-card no-body @click="addVideo()" class="add-item cursor">
                                  <b-card-body body-bg-variant="default" class="d-flex justify-content-center align-items-center" style="min-height: 150px;">
                                    <font-awesome-icon :icon="['fas', 'plus']" class="align-middle" v-b-tooltip="'Добавить видео'" />
                                  </b-card-body>
                                </b-card>
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-card>
                        <b-modal id="video-preview" centered no-close-on-backdrop hide-header hide-footer size="xl" @show="loadComments(currentVideo)">
                          <b-button-close @click="$bvModal.hide('video-preview')" class="text-white" style="position: absolute; right: -2%; top: 1%; font-size: 3rem;" />
                          <transition name="fade">
                            <b-container v-if="currentVideo" fluid :key="currentVideo.id">
                              <b-row class="px-0">
                                <b-col cols="8" class="py-3 image d-flex justify-content-center align-items-center">
                                  <b-button class="prev" :disabled="currentVideoIndex === 0" variant="link" @click="showVideo(-1)">
                                    <font-awesome-icon :icon="['fas', 'chevron-left']" />
                                  </b-button>
                                  <b-button class="next" :disabled="currentVideoIndex === (videos.length - 1)" variant="link" @click="showVideo(+1)">
                                    <font-awesome-icon :icon="['fas', 'chevron-right']" />
                                  </b-button>

                                  <div class="videowrapper" v-html="currentVideo.player"></div>

                                  <b-button size="sm" variant="outline-light" class="position-absolute" style="top: 3px; left: 3px;" :pressed="currentVideo.votes.self" @click="vote('video')" :disabled="voting" v-b-tooltip="'Количество голосов'">
                                    <font-awesome-icon v-if="!voting" :icon="['fas', 'heart']" />
                                    <font-awesome-icon v-else :icon="['fas', 'spinner']" spin />
                                    <b-badge variant="transparent">{{ currentVideo.votes.count }}</b-badge>
                                  </b-button>
                                  <b-button size="sm" variant="outline-danger" class="position-absolute" style="top: 3px; right: 3px;" @click="deleteVideo()" :disabled="deleting" v-b-tooltip="'Удалить'">
                                    <font-awesome-icon v-if="!deleting" icon="trash-alt" />
                                    <font-awesome-icon v-else icon="spinner" spin />
                                  </b-button>
                                </b-col>
                                <b-col cols="4" class="py-3 comments d-flex flex-column">
                                  <b-row class="flex-grow-1 comments-list">
                                    <b-col class="comments-list" style="font-size: 85%;">
                                      <div v-for="comment in Object.values(currentVideo.comments).filter(c => !c.parent).reverse()" :key="comment.id" class="mb-1 d-flex flex-row align-items-start">
                                        <b-img :src="comment.author.avatar" rounded="circle" width="30" class="mr-3 mb-1 float-left" />
                                        <div>
                                          <b>{{ comment.author.fullname }}:</b>
                                          <div v-html="comment.message" style="white-space: pre-wrap; word-break: break-all;" />
                                        </div>
                                      </div>
                                    </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col>
                                      <comment-form :object="currentVideo" type="video" />
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-container>
                          </transition>
                        </b-modal>
                      </template>
                      <p v-else>
                        <b-alert
                          variant="warning"
                          show
                        >
                          Тут еще нет записей...
                        </b-alert>
                      </p>
                      <b-button v-if="isOwner" size="sm" @click="addVideo()">Добавить видео</b-button>
                    </b-tab>

                    <b-tab
                      title="Библиотека"
                      :active="activeTab === 'library'"
                      title-item-class="ml-auto"
                      @click="activeTab = 'library'"
                    >
                      <b-alert
                        v-if="library.length === 0"
                        :show="true"
                        variant="warning"
                      >
                        Еще не загружено ни одного файла
                      </b-alert>
                      <b-card v-else class="mb-3">
                        <b-table
                          :items="library"
                          :fields="libFields"
                          hover
                          :tbody-tr-class="(item, type) => item.type === 'catalog' ? 'cursor' : ''"
                          @row-clicked="libraryItemSelected(arguments[0])"
                        >
                          <template v-slot:table-colgroup="scope">
                            <col
                              v-for="field in scope.fields"
                              :key="field.key"
                              :style="{ width: field.key === 'title' ? '100%' : 'auto' }"
                            >
                          </template>
                          <template #cell(title)="{ item }">
                            <div :style="{ marginLeft: item.level + 'rem' }">
                              <font-awesome-icon v-if="item.type === 'catalog' && !item.opened" :icon="['far', 'folder']" />
                              <font-awesome-icon v-if="item.type === 'catalog' && item.opened" :icon="['far', 'folder-open']" />
                              <font-awesome-icon v-if="item.type === 'file'" :icon="['far', item.icon]" />
                              {{ item.title }}
                            </div>
                          </template>
                          <template #cell(published)="{ item }">
                            <div v-if="item.type === 'file'">
                              {{ item.uploaded | fullDate }}
                            </div>
                          </template>
                          <template #cell(actions)="{ item }">
                            <template v-if="isOwner">
                              <b-button
                                size="sm"
                                class="mr-1"
                                @click="editLibraryItem(item)"
                                v-b-tooltip="'Редактировать'"
                              >
                                <font-awesome-icon :icon="['far', 'edit']" />
                              </b-button>
                              <b-button
                                size="sm"
                                class="mr-1"
                                @click="removeLibraryItem(item)"
                                v-b-tooltip="'Удалить'"
                                variant="danger"
                              >
                                <font-awesome-icon :icon="['fas', 'trash-alt']" />
                              </b-button>
                            </template>
                            <b-button
                              v-if="item.type === 'file'"
                              size="sm"
                              class="mr-1"
                              @click="openFile(item)"
                              v-b-tooltip="'Открыть'"
                            >
                              <font-awesome-icon :icon="['fas', 'share']" />
                            </b-button>
                          </template>
                        </b-table>
                      </b-card>

                      <template v-if="isOwner">
                        <b-button
                          size="sm"
                          @click="addFile()"
                        >
                          Добавить файл в библиотеку
                        </b-button>
                        <b-button
                          size="sm"
                          @click="addCatalog()"
                          class="ml-1"
                        >
                          Добавить каталог
                        </b-button>
                      </template>
                    </b-tab>
                  </b-tabs>
                </b-col>
              </b-row>
            </b-container>
          </template>
        </b-col>
        <b-col sm="12" md="4" lg="3">
          <b-card body-class="px-0 py-1" class="mb-3">
            <sub-menu-block />
          </b-card>
          <b-card v-if="isOwner" body-class="px-0 py-1">
            <b-nav vertical class="sub-menu-actions">
              <b-nav-item @click="addPost()"><font-awesome-icon :icon="['fas', 'newspaper']" /> Добавить статью</b-nav-item>
              <b-nav-item @click="addPhoto()"><font-awesome-icon :icon="['fas', 'image']" /> Добавить фото</b-nav-item>
              <b-nav-item @click="addVideo()"><font-awesome-icon :icon="['fas', 'film']" /> Добавить видео</b-nav-item>
              <b-nav-item @click="addFile()"><font-awesome-icon :icon="['fas', 'file-upload']" /> Добавить файл</b-nav-item>
            </b-nav>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <template v-if="isOwner">
      <b-modal id="edit-post-modal" size="xl" scrollable v-model="showPostForm" no-enforce-focus :title="editablePost.id ? 'Редактирование статьи' : 'Новая статья'" ok-title="Сохранить" cancel-title="Отмена" cancel-variant="primary" @ok="savePost()" :ok-disabled="!editablePost.title || !editablePost.excerpt || !editablePost.article" no-close-on-backdrop>
        <post-form :post="editablePost" @apply="editablePost = $event" />
      </b-modal>
      <b-modal
        id="edit-photo-modal"
        size="lg"
        v-model="showPhotoForm"
        no-enforce-focus
        title="Фотогаллерея"
        ok-title="Загрузить"
        cancel-title="Отмена"
        cancel-variant="primary"
        @ok="savePhoto()"
        :ok-disabled="editablePhotos.length === 0"
        no-close-on-backdrop
      >
        <photo-form v-model="editablePhotos" />
      </b-modal>
      <b-modal
        id="edit-video-modal"
        size="lg"
        v-model="showVideoForm"
        no-enforce-focus
        title="Видеогаллерея"
        ok-title="Сохранить"
        cancel-title="Отмена"
        cancel-variant="primary"
        @ok="saveVideo()"
        :ok-disabled="!editableVideo.title || !editableVideo.url || !editableVideo.valid"
        no-close-on-backdrop
      >
        <video-form v-model="editableVideo" />
      </b-modal>
      <b-modal
        id="edit-file-modal"
        size="md"
        v-model="showFileForm"
        no-enforce-focus
        title="Библиотека"
        ok-title="Сохранить"
        cancel-title="Отмена"
        cancel-variant="primary"
        @ok="saveFile()"
        :ok-disabled="!editableFile.title"
        no-close-on-backdrop
      >
        <file-form
          v-model="editableFile"
          :catalogs="treeCatalogs"
        />
      </b-modal>
      <b-modal
        id="edit-catalog-modal"
        size="md"
        v-model="showCatalogForm"
        no-enforce-focus
        title="Библиотека"
        :ok-title="editableCatalog.id ? 'Сохранить' : 'Добавить'"
        cancel-title="Отмена"
        cancel-variant="primary"
        @ok="saveCatalog()"
        :ok-disabled="!editableCatalog.title"
        no-close-on-backdrop
      >
        <catalog-form
          v-model="editableCatalog"
          :catalogs="treeCatalogs"
        />
      </b-modal>
    </template>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SubMenuBlock from '@/blocks/CabinetSubMenu'
import PostBlock from '@/components/Post'
import PhotoBlock from '@/components/Photo'
import VideoBlock from '@/components/Video'
import CommentBlock from '@/components/Comment'
import PostForm from '@/components/forms/Post'
import VideoForm from '@/components/forms/Video'
import PhotoForm from '@/components/forms/Photo'
import FileForm from '@/components/forms/File'
import CatalogForm from '@/components/forms/Catalog'
import CommentForm from '@/components/forms/Comment'
import TextEditor from '@/components/Editor'
import AvatarBlock from '@/components/Avatar'
import { full as fullDate } from '@/filters/date'

export default {
  components: {
    SubMenuBlock,
    PostBlock,
    PhotoBlock,
    VideoBlock,
    CommentBlock,
    PostForm,
    VideoForm,
    PhotoForm,
    FileForm,
    CatalogForm,
    CommentForm,
    TextEditor,
    AvatarBlock
  },
  filters: {
    fullDate
  },
  data: () => ({
    error: false,

    isEditAboutPriest: false,
    editableAboutPriest: '',
    saving: false,

    activeTab: 'post',

    voting: false,

    currentPhoto: null,
    currentVideo: null,

    currentPage: 1,
    postsPerPage: 5,

    showPostForm: false,
    showPhotoForm: false,
    showVideoForm: false,
    showFileForm: false,
    showCatalogForm: false,

    editablePost: {},
    editableVideo: {},
    editablePhotos: [],
    editableFile: {},
    editableCatalog: {},

    deleting: false,

    libFields: [{
      key: 'title',
      label: 'Название',
      sortable: false
    }, {
      key: 'published',
      label: 'Дата загрузки',
      sortable: false,
      thAttr: { nowrap: true },
      tdAttr: { nowrap: true }
    }, {
      key: 'actions',
      label: '',
      sortable: false,
      tdAttr: { nowrap: true }
    }],
    libItems: []
  }),
  computed: {
    ...mapGetters('AuthModule', {
      isAuthenticated: 'isAuthenticated'
    }),
    ...mapState('UserModule', {
      userID: 'id',
      isPriest: 'priest'
    }),
    ...mapState('ParishModule', {
      activeParish: 'current'
    }),
    ...mapGetters('BlogModule', {
      posts: 'currentParishPosts',
      photos: 'currentParishPhotos',
      videos: 'currentParishVideos',
      aboutPriest: 'currentParishAboutPriest',
      libFiles: 'currentParishFiles',
      libCatalogs: 'currentParishCatalogs'
    }),
    currentParish () {
      return this.$store.getters['ParishModule/currentParish']
    },
    isOwner () {
      return this.isPriest && this.activeParish && this.activeParish.priest.id === this.userID
    },
    isUserCanComment () {
      return this.isAuthenticated && this.activeParish
    },
    currentPost () {
      return this.posts.find(item => {
        return item.id === this.$route.query.post
      })
    },
    currentPhotoIndex () {
      if (!this.currentPhoto) {
        return -1
      }

      return this.photos.findIndex(photo => photo.id === this.currentPhoto.id)
    },
    currentVideoIndex () {
      if (!this.currentVideo) {
        return -1
      }

      return this.videos.findIndex(video => video.id === this.currentVideo.id)
    },
    breadcrumbs () {
      let items = []

      items.push({
        text: this.$t('cabinet.dashboard'),
        to: { name: 'cabinet' }
      })

      items.push({
        text: this.$t(`cabinet.blocks.blog.${this.currentParish.titles.blog}`),
        to: { name: 'cabinet_blog' }
      })

      if (this.currentPost) {
        items.push({
          text: this.currentPost.title,
          to: { name: 'cabinet_blog', query: { post: this.currentPost.id } },
          active: true
        })
      }

      return items
    },
    library () {
      const catalogs = Object.values(this.libCatalogs).filter(catalog => {
        return !catalog.parent || !!this.libCatalogs[catalog.parent].opened
      }).map(catalog => {
        let c = { ...catalog }
        c.type = 'catalog'
        c.opened = !!catalog.opened
        return c
      })
      const files = Object.values(this.libFiles).filter(file => {
        return !file.catalog || catalogs.some(catalog => catalog.id === file.catalog && catalog.opened)
      }).map(file => {
        let f = { ...file }
        f.type = 'file'
        f.level = f.catalog ? this.libCatalogs[f.catalog].level + 1 : 0
        return f
      })
      let items = [
        ...catalogs,
        ...files
      ]

      console.log(items)

      const getCombinedName = (item) => {
        const parent = (item.type === 'catalog') ? item.parent : item.catalog
        const prefix = (item.type === 'catalog') ? '1' : '2'

        if (parent) {
          return getCombinedName({ ...this.libCatalogs[parent], type: 'catalog' }) + prefix + item.title
        }

        return prefix + item.title
      }

      items.forEach(item => {
        item.combined = getCombinedName(item)
      })

      items.sort((a, b) => a.combined.localeCompare(b.combined))

      items.forEach(item => {
        console.log(item.combined)
      })

      return items
    },
    treeCatalogs () {
      const getCombinedName = (item) => {
        if (item.parent) {
          return getCombinedName({ ...this.libCatalogs[item.parent], type: 'catalog' }) + item.title
        }

        return item.title
      }

      return Object.values(this.libCatalogs).map(catalog => {
        let c = { ...catalog }
        c.combined = getCombinedName(c)
        return c
      }).sort(this.sortCatalogs).map(catalog => {
        let c = { ...catalog }
        c.title = '-'.repeat(c.level) + ' ' + c.title
        return c
      })
    }
  },
  watch: {
    currentPost (post) {
      if (post && !post.article) {
        this.loadPost(post)
      }
    },
    activeParish (parish) {
      if (this.currentPost) {
        return
      }
      this.loadLastPosts(parish)
      this.loadLastPhotos(parish)
      this.loadLastVideos(parish)
    },
    activeTab (tab) {
      if (tab === 'video' && window.FB) {
        console.log('parse')
        window.FB.XFBML.parse()
      }
    }
  },
  mounted () {
    if (!this.currentPost) {
      this.loadLastPosts()
      this.loadLastPhotos()
      this.loadLastVideos()
      this.loadLibrary()
    }
    this.loadAboutPriest()
  },
  methods: {
    sortCatalogs (a, b) {
      // if (a.level === b.level) {
      //   return a.title.localeCompare(b.title)
      // }
      //
      // return a.level - b.level

      return a.combined.localeCompare(b.combined)
    },
    async loadComments (item) {},
    editLibraryItem (item) {
      switch (item.type) {
        case 'catalog':
          this.editableCatalog = item
          this.showCatalogForm = true
          break
        case 'file':
          this.editableFile = item
          this.showFileForm = true
          break
        default:
          console.log(item)
      }
    },
    removeLibraryItem (item) {
      const h = this.$createElement
      const messages = []

      messages.push(h('p', 'Вы действительно хотите удалить ' + (item.type === 'catalog' ? 'каталог' : 'файл') + ` "${item.title}"?`))

      if (item.type === 'catalog') {
        messages.push(h('p', { 'class': 'small' }, 'Будет также удалено все содержимое этого каталога!'))
      }
      this.$bvModal.msgBoxConfirm(h('div', messages), {
        title: 'Вы уверены',
        size: 'md',
        // buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Да',
        cancelTitle: 'Нет',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(confirmed => {
          if (confirmed) {
            this.$store.dispatch('BlogModule/removeLibraryItem', { parish: this.activeParish, item })
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    libraryItemSelected (item) {
      switch (item.type) {
        case 'file':
          // this.openFile(item)
          break
        case 'catalog':
          this.toggleCatalog(item)
          break
        default:
          console.error(item)
      }
    },
    openFile (file) {
      console.log(file)
      window.open(file.url, '_blank')
    },
    toggleCatalog (catalog) {
      if (catalog.opened) {
        this.closeCatalog(catalog)
      } else {
        this.openCatalog(catalog)
      }
    },
    openCatalog (catalog) {
      this.$store.dispatch('BlogModule/openCatalog', { parish: this.activeParish, catalog })
    },
    closeCatalog (catalog) {
      this.$store.dispatch('BlogModule/closeCatalog', { parish: this.activeParish, catalog })
    },
    async vote (itemType) {
      this.voting = true
      switch (itemType) {
        case 'photo':
          await this.$store.dispatch('BlogModule/votePhoto', { parish: this.activeParish, photo: this.currentPhoto })
          break
        case 'video':
          await this.$store.dispatch('BlogModule/voteVideo', { parish: this.activeParish, video: this.currentVideo })
          break
        default:
          console.log(itemType)
      }
      this.voting = false
    },
    editAboutPriest () {
      this.editableAboutPriest = this.aboutPriest
      this.isEditAboutPriest = true
    },
    async saveAboutPriest () {
      this.saving = true
      await this.$store.dispatch('UserModule/saveAboutPriest', this.editableAboutPriest)
      this.saving = false
      this.isEditAboutPriest = false
    },
    async loadPost (post) {
      this.$busy()
      await this.$store.dispatch('BlogModule/loadPost', { parish: this.activeParish, post })
      this.$idle()
    },
    showPhotoPreview (photo) {
      this.currentPhoto = photo
      this.$bvModal.show('photo-preview')
    },
    showVideoPreview (video) {
      this.currentVideo = video
      this.$bvModal.show('video-preview')

      this.$nextTick(() => {
        window.FB.XFBML.parse()
      })
    },
    showPhoto (step) {
      this.currentPhoto = this.photos[this.currentPhotoIndex + step]
    },
    showVideo (step) {
      this.currentVideo = this.videos[this.currentVideoIndex + step]

      this.$nextTick(() => {
        setTimeout(() => {
          window.FB.XFBML.parse()
        }, 0)
      })
    },
    async deletePhoto () {
      const confirmed = await this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить эту фотографию?', {
        title: 'Внимание!',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Да',
        cancelTitle: 'Нет',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0'
      })

      if (!confirmed) {
        return
      }

      this.deleting = true
      try {
        const message = await this.$store.dispatch('BlogModule/deletePhoto', { parish: this.activeParish, photo: this.currentPhoto })
        this.$bvModal.hide('photo-preview')
        this.currentPhoto = null
        this.$bvToast.toast(this.$t(`messages.${message}`), {
          variant: 'info',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true,
          autoHideDelay: 3000
        })
      } catch (e) {
        console.error(e)
        this.$bvToast.toast(e.message || this.$t('messages.error_occurred'), {
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })
      }
      this.deleting = false
    },
    async deleteVideo () {
      const confirmed = await this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить это видео?', {
        title: 'Внимание!',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Да',
        cancelTitle: 'Нет',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0'
      })

      if (!confirmed) {
        return
      }

      this.deleting = true
      try {
        const message = await this.$store.dispatch('BlogModule/deleteVideo', { parish: this.activeParish, video: this.currentVideo })
        this.$bvModal.hide('video-preview')
        this.currentVideo = null
        this.$bvToast.toast(this.$t(`messages.${message}`), {
          variant: 'info',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true,
          autoHideDelay: 3000
        })
      } catch (e) {
        console.error(e)
        this.$bvToast.toast(e.message || this.$t('messages.error_occurred'), {
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })
      }
      this.deleting = false
    },
    async loadAboutPriest () {
      this.$busy()
      try {
        await this.$store.dispatch('BlogModule/loadAboutPriest', this.activeParish.priest)
      } catch (error) {
        console.log(error)
      }
      this.$idle()
    },
    addPost () {
      this.editablePost = {
        title: '',
        excerpt: '',
        article: ''
      }
      this.showPostForm = true
    },
    async editPost (post) {
      await this.loadPost(post)
      this.editablePost = this.posts.filter(p => p.id === post.id)[0]
      this.showPostForm = true
    },
    async savePost () {
      this.$busy()
      try {
        await this.$store.dispatch('BlogModule/savePost', { parish: this.activeParish, post: this.editablePost })
        this.error = false
      } catch (error) {
        this.error = true
        this.$bvToast.toast(error.message, {
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })
      }
      this.$idle()
    },
    async loadLastPosts () {
      if (!this.activeParish) return
      this.$busy()
      try {
        await this.$store.dispatch('BlogModule/loadLastPosts', this.activeParish)
      } catch (error) {
        console.log(error.message)
      }
      this.$idle()
    },
    async loadLastPhotos () {
      if (!this.activeParish) return
      this.$busy()
      try {
        await this.$store.dispatch('BlogModule/loadLastPhotos', this.activeParish)
      } catch (error) {
        console.log(error.message)
      }
      this.$idle()
    },
    async loadLastVideos () {
      if (!this.activeParish) return
      this.$busy()
      try {
        await this.$store.dispatch('BlogModule/loadLastVideos', this.activeParish)
      } catch (error) {
        console.log(error.message)
      }
      this.$idle()
    },
    async loadLibrary () {
      if (!this.activeParish) return
      this.$busy()
      try {
        await this.$store.dispatch('BlogModule/loadLibrary', this.activeParish)
      } catch (error) {
        console.log(error.message)
      }
      this.$idle()
    },

    addPhoto () {
      this.editablePhotos = []
      this.showPhotoForm = true
    },
    async savePhoto () {
      this.$busy()
      try {
        const images = this.editablePhotos.map(i => i.getAll('file')).flat()
        await this.$store.dispatch('BlogModule/savePhoto', { parish: this.activeParish, images })
      } catch (error) {
        this.error = true
        this.$bvToast.toast(error.message, {
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })
      }
      this.$idle()
    },

    addVideo () {
      this.editableVideo = {
        id: null,
        valid: false,
        title: '',
        url: ''
      }
      this.showVideoForm = true
    },
    async saveVideo () {
      this.$busy()
      try {
        await this.$store.dispatch('BlogModule/saveVideo', { parish: this.activeParish, video: this.editableVideo })
        this.error = false
      } catch (error) {
        this.error = true
        this.$bvToast.toast(error.message, {
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })
      }
      this.$idle()
    },

    scrollPostsToTop () {
      this.$refs.tabs.$el.scrollIntoView({
        behavior: 'smooth'
      })
    },

    addFile () {
      this.editableFile = {
        id: null,
        catalog: null,
        title: '',
        blob: null
      }
      this.showFileForm = true
    },
    async saveFile () {
      this.$busy()
      try {
        const file = this.editableFile
        file.file = file.blob
        delete file.blob
        await this.$store.dispatch('BlogModule/saveFile', { parish: this.activeParish, file })
        this.error = false
      } catch (error) {
        this.error = true
        this.$bvToast.toast(error.message, {
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })
      }
      this.$idle()
    },

    addCatalog () {
      this.editableCatalog = {
        id: null,
        title: '',
        parent: null
      }
      this.showCatalogForm = true
    },
    async saveCatalog () {
      this.$busy()
      try {
        const catalog = {
          id: this.editableCatalog.id,
          title: this.editableCatalog.title,
          parent: this.editableCatalog.parent
        }
        await this.$store.dispatch('BlogModule/saveCatalog', { parish: this.activeParish, catalog })
        this.error = false
      } catch (error) {
        this.error = true
        this.$bvToast.toast(error.message, {
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })
      }
      this.$idle()
    }
  }
}
</script>

<style lang="scss">
article {
  blockquote {
    overflow: hidden;
    padding-right: 1.5em;
    padding-left: 1.5em;
    margin-left: 0;
    margin-right: 0;
    font-style: italic;
    border-left: 5px solid #ccc;
  }
}
#comments {
  position: relative;
  top: -60px;
}
.sub-menu-actions {
  li {
    margin-bottom: .2rem;
    a {
      // background-color:
      display: block;
      color: rgb(113, 98, 111);

      &:hover {
        background-color: rgba(128, 109, 101, .2);
      }

      &.router-link-active {
        background-color: rgba(128, 109, 101, .2);
      }
    }
  }
}
.card.add-item {
  font-size: 3rem;
  color: rgb(113, 98, 111) !important;

  .card-body {
    background-color: rgba(200,200,200,.4);
    opacity: .5;
    &:hover {
      opacity: .8;
    }
  }
}
[id$="-preview"] {
  .prev {
    position: absolute;
    top: 0;
    bottom: 0;
    padding: 0 2%;
    left: 0;
    color: #aaaaaa;
    font-size: 4rem;
    line-height: 5rem;
    cursor: pointer;
    &:hover {
      background-color: rgba(220, 220, 220, .1);
      color: #ffffff;
    }
  }
  .next {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    padding: 0 2%;
    color: #aaaaaa;
    font-size: 4rem;
    line-height: 5rem;
    cursor: pointer;
    &:hover {
      background-color: rgba(220, 220, 220, .1);
      color: #ffffff;
    }
  }
  .modal-content {
    background-color: transparent;
    border: none;
  }

  .modal-body {
    background-color: transparent;
  }

  .image {
    background-color: #000;

    max-height: 75vh;

    img {
      width: auto;
      max-height: 75vh;
    }
  }

  .comments {
    background-color: #fff;

    min-height: 50vh;
    max-height: 75vh;

    overflow-x: hidden;
    overflow-y: hidden;

    .comments-list {
      overflow-y: auto;
    }
  }
}
.videowrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
  width: 100%;
  margin: 0 4rem;
}
.videowrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
/*div[data-oembed-url] {*/
/*  & > div {*/
/*    min-width: 100%;*/
/*    min-height: 250px;*/
/*  }*/
/*}*/
</style>
